import Form from '../components/Form';

const Home = (): JSX.Element => {
  return (
    <div id="home">
      <Form />
    </div>
  );
};

export default Home;
